import type BusinessProcessBase from '../shapes/BusinessProcessBase';
import ShapeBusinessProcessActivity from '../shapes/ShapeBusinessProcessActivity';
import ShapeBusinessProcessData from '../shapes/ShapeBusinessProcessData';
import ShapeBusinessProcessDataStore from '../shapes/ShapeBusinessProcessDataStore';
import ShapeBusinessProcessEvent from '../shapes/ShapeBusinessProcessEvent';
import ShapeBusinessProcessGateway from '../shapes/ShapeBusinessProcessGateway';
import { type BusinessProcessShapeNames } from './definitions';

export const businessProcessShapeClasses: Record<
  BusinessProcessShapeNames,
  typeof BusinessProcessBase
> = {
  businessProcessEvent: ShapeBusinessProcessEvent,
  businessProcessActivity: ShapeBusinessProcessActivity,
  businessProcessGateway: ShapeBusinessProcessGateway,
  businessProcessData: ShapeBusinessProcessData,
  businessProcessDataStore: ShapeBusinessProcessDataStore,
};
